function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import isObjectLike from 'lodash/isObjectLike';
import ErrorIcon from 'svg/error.svg';
import intlShape from 'shapes/intlShape';
import messages from './messages';
var _React_PureComponent;
/**
 * Essential macro-like form segment
 *
 * @param {string} id - unique id
 * @param {Element} children - Component children from composition
 * @param {Object} [labelMessage=null] - Intl message label for input label
 * @param {boolean} [isRequired=false] - marker for required fields
 * @param {Object} [formValues] - parent form values state
 * @param {Object} [errorsMessages={}] - Intl message label for input descriptionMessage
 */ class FormGroup extends (_React_PureComponent = React.PureComponent) {
    get isOptional() {
        const { validatorRules, id } = this.props;
        if (!validatorRules) return false;
        return validatorRules && (!validatorRules[id] || !validatorRules[id].includes('required'));
    }
    renderActionElement() {
        if (!this.props.actionElement) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-auto",
            children: /*#__PURE__*/ _jsx("span", {
                className: "form-action-element",
                children: this.props.actionElement
            })
        });
    }
    renderLabel(hasError) {
        if (!this.props.labelMessage) {
            return null;
        }
        let Content;
        if (/*#__PURE__*/ React.isValidElement(this.props.labelMessage)) {
            Content = this.props.labelMessage;
        } else if (isObjectLike(this.props.labelMessage)) {
            Content = this.props.intl.formatMessage(this.props.labelMessage, _object_spread({}, this.props.labelMessage.values));
        } else {
            Content = this.props.labelMessage;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: `col-${this.props.isOneLiner ? 3 : '12 mb-4'}`,
            children: /*#__PURE__*/ _jsxs("label", {
                className: cn('form-label', {
                    'text--error': hasError
                }),
                htmlFor: this.props.id,
                children: [
                    Content,
                    this.renderIsOptional()
                ]
            })
        });
    }
    renderInfo() {
        if (!this.props.infoMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "form-info",
            children: isObjectLike(this.props.infoMessage) ? this.props.intl.formatMessage(this.props.infoMessage, _object_spread({}, this.props.infoMessage.values)) : this.props.infoMessage
        });
    }
    renderIsOptional() {
        if (!this.isOptional) {
            return null;
        }
        return /*#__PURE__*/ _jsx("span", {
            className: "text--disabled",
            children: ` - ${this.props.intl.formatMessage(messages.labels.optional)}`
        });
    }
    renderErrors(errors) {
        if (!errors) {
            return null;
        }
        const errorsMessages = _object_spread({}, messages.validationErrors, this.props.errorsMessages);
        return map(errors, (params, error)=>/*#__PURE__*/ _jsxs("div", {
                className: "form-text form-error",
                children: [
                    /*#__PURE__*/ _jsx(ErrorIcon, {}),
                    this.props.intl.formatMessage(_object_spread({}, errorsMessages[error]), params)
                ]
            }, error));
    }
    renderBEErrors(errors) {
        if (!errors) {
            return null;
        }
        return map(errors, (params, error)=>/*#__PURE__*/ _jsx("p", {
                className: "form-text text--error",
                children: params
            }, error));
    }
    render() {
        // TODO: Check scopes nesting in modules/Country/components/ConfigureCountry/tabs/General/index.js
        let value = get(this.props.formValues, `values.${this.props.id}`, '');
        if (this.props.children.props.isMulti) {
            value = value || [];
        } else {
            value = value || value === 0 ? value : '';
        }
        const errors = get(this.props.formValues, [
            'errors',
            this.props.id
        ], null);
        const BEErrors = get(this.props.formValues, [
            'BEValidationErrors',
            this.props.id
        ], null);
        const hasError = !isEmpty(errors) || !isEmpty(BEErrors);
        const input = /*#__PURE__*/ React.cloneElement(this.props.children, {
            id: this.props.children.props.id ? this.props.children.props.id : this.props.id,
            value,
            hasError
        });
        const { isOneLiner } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: cn('form-group', {
                'form-group--one-liner': isOneLiner
            }, this.props.className),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    this.renderLabel(hasError),
                    /*#__PURE__*/ _jsxs("div", {
                        className: `col-${isOneLiner ? 6 : 12}`,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col",
                                        children: React.Children.only(input)
                                    }),
                                    this.renderActionElement()
                                ]
                            }),
                            this.renderErrors(errors),
                            this.renderBEErrors(BEErrors),
                            this.renderInfo()
                        ]
                    })
                ]
            })
        });
    }
}
_define_property(FormGroup, "propTypes", {
    // Explicit props
    id: PropTypes.string.isRequired,
    formValues: PropTypes.object,
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    infoMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.node
    ]),
    errorsMessages: PropTypes.object,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    actionElement: PropTypes.element,
    validatorRules: PropTypes.object,
    isOneLiner: PropTypes.bool,
    // boundAsyncData    : PropTypes.any,
    // Implicit props
    children: PropTypes.element.isRequired,
    intl: intlShape.isRequired
});
_define_property(FormGroup, "defaultProps", {
    labelMessage: null,
    errorsMessages: {},
    isOneLiner: false
});
export default injectIntl(FormGroup);
